import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import { Menu, Segment, Header } from 'semantic-ui-react';
import MenuItems from './components/MenuItems';
import MobileMenu from './components/MobileMenu';
import Image from '../../atoms/Image';
import InternalLink from '../../atoms/InternalLink';
import { groupLinks, transformLinks } from '../../modules/navigation/services/links';
import { AsPropType, ImagePropType, LinkPropType, TextAlignPropType } from '../../services/proptypes';
import './Navigation.css';

// @deprecated: prefer using Navigation component of the navigation module
var Navigation = /*#__PURE__*/function (_React$Component) {
  _inherits(Navigation, _React$Component);
  var _super = _createSuper(Navigation);
  function Navigation() {
    _classCallCheck(this, Navigation);
    return _super.apply(this, arguments);
  }
  _createClass(Navigation, [{
    key: "getWidthsProps",
    value: function getWidthsProps() {
      var links = this.props.links;
      var count = this.logoHasOwnRow() ? links.length : links.length + 1;
      return this.isEvenSpacing() ? {
        widths: count
      } : {};
    }
  }, {
    key: "getLinks",
    value: function getLinks() {
      var disabledGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$props = this.props,
        group = _this$props.group,
        links = _this$props.links;
      return group && !disabledGroups ? groupLinks(links) : transformLinks(links);
    }
  }, {
    key: "getContainerClassNames",
    value: function getContainerClassNames() {
      var _this$props2 = this.props,
        fixed = _this$props2.fixed,
        backgroundColor = _this$props2.backgroundColor;
      var classNames = 'navigation-container';
      if (fixed) {
        classNames += ' navigation-container-top-fixed';
      } else {
        classNames += ' navigation-container-top';
      }
      if (backgroundColor === 'primary') {
        classNames += ' navigation-primary-background';
      } else if (backgroundColor === 'secondary') {
        classNames += ' navigation-secondary-background';
      }
      return classNames;
    }
  }, {
    key: "getContainerStyle",
    value: function getContainerStyle() {
      var backgroundColor = this.props.backgroundColor;
      var additionalStyle = backgroundColor !== 'primary' && backgroundColor !== 'none' ? {
        backgroundColor: backgroundColor,
        color: 'white !important'
      } : {};
      return additionalStyle;
    }
  }, {
    key: "getPrimaryContent",
    value: function getPrimaryContent(mobile) {
      var _this$props3 = this.props,
        header = _this$props3.header,
        logo = _this$props3.logo;
      var content = null;
      var wrapAsMenuItem = false;
      if (logo) {
        content = /*#__PURE__*/React.createElement(Image, {
          height: mobile ? 50 : 60,
          src: logo,
          centered: true
        });
        wrapAsMenuItem = true;
      } else if (mobile) {
        content = /*#__PURE__*/React.createElement(Header, {
          as: "h3",
          style: {
            verticalAlign: 'middle',
            textAlign: 'center'
          }
        }, header);
      } else {
        content = this.logoHasOwnRow() ? /*#__PURE__*/React.createElement(Header, {
          as: "h2",
          style: {
            textAlign: 'center',
            marginTop: 0
          }
        }, header) : /*#__PURE__*/React.createElement(Header, {
          as: "h3",
          style: {
            verticalAlign: 'middle',
            textAlign: 'center'
          }
        }, header);
        wrapAsMenuItem = !this.logoHasOwnRow();
      }
      var primaryContent = /*#__PURE__*/React.createElement(InternalLink, {
        to: "/"
      }, content);
      return wrapAsMenuItem ? /*#__PURE__*/React.createElement(Menu.Item, {
        header: true,
        style: {
          textAlign: 'center'
        }
      }, primaryContent) : primaryContent;
    }
  }, {
    key: "isEvenSpacing",
    value: function isEvenSpacing() {
      var _this$props4 = this.props,
        evenSpacing = _this$props4.evenSpacing,
        primaryContentPosition = _this$props4.primaryContentPosition,
        links = _this$props4.links,
        logo = _this$props4.logo,
        header = _this$props4.header;
      var isMiddleWithEvenLinks = primaryContentPosition === 'middle' && links.length % 2 === 0;
      var noHeaderOrLogo = header.length === 0 && logo.length === 0;
      return evenSpacing && (isMiddleWithEvenLinks || primaryContentPosition === 'top') || noHeaderOrLogo;
    }
  }, {
    key: "logoHasOwnRow",
    value: function logoHasOwnRow() {
      var primaryContentPosition = this.props.primaryContentPosition;
      return primaryContentPosition === 'top';
    }
  }, {
    key: "renderMenuItems",
    value: function renderMenuItems() {
      var _this$props5 = this.props,
        linksAs = _this$props5.linksAs,
        primaryContentPosition = _this$props5.primaryContentPosition,
        header = _this$props5.header,
        logo = _this$props5.logo,
        backgroundColor = _this$props5.backgroundColor,
        className = _this$props5.className;
      var links = this.getLinks();
      if (primaryContentPosition === 'top' || !header && !logo) {
        return /*#__PURE__*/React.createElement(MenuItems, {
          backgroundColor: backgroundColor,
          linksAs: linksAs,
          links: links,
          className: className
        });
      }
      if (primaryContentPosition === 'middle' && links.length % 2 === 0) {
        var linksLength = links.length;
        var linksPivot = Math.floor(linksLength / 2);
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuItems, {
          backgroundColor: backgroundColor,
          linksAs: linksAs,
          links: links.slice(0, linksPivot),
          className: className
        }), /*#__PURE__*/React.createElement(Menu.Item, null, this.getPrimaryContent()), /*#__PURE__*/React.createElement(MenuItems, {
          backgroundColor: backgroundColor,
          linksAs: linksAs,
          links: links.slice(linksPivot),
          className: className
        }));
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.getPrimaryContent(), /*#__PURE__*/React.createElement(Menu.Menu, {
        position: "right",
        className: "fisherman-navigation-right-menu"
      }, /*#__PURE__*/React.createElement(MenuItems, {
        backgroundColor: backgroundColor,
        linksAs: linksAs,
        links: links
      })));
    }
  }, {
    key: "renderNavContainer",
    value: function renderNavContainer(child) {
      if (this.logoHasOwnRow()) {
        return /*#__PURE__*/React.createElement("div", {
          style: this.getContainerStyle()
        }, /*#__PURE__*/React.createElement(Segment, {
          className: this.getContainerClassNames()
        }, /*#__PURE__*/React.createElement(Menu.Item, null, this.getPrimaryContent()), child));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: this.getContainerClassNames(),
        style: this.getContainerStyle()
      }, child);
    }
  }, {
    key: "renderDesktopNav",
    value: function renderDesktopNav() {
      var _this$props6 = this.props,
        bordered = _this$props6.bordered,
        fixed = _this$props6.fixed;
      var menuFixed = !this.logoHasOwnRow() && fixed ? 'top' : null;
      return this.renderNavContainer(/*#__PURE__*/React.createElement(Menu, _extends({
        stackable: true,
        borderless: !bordered,
        size: "large",
        fixed: menuFixed
      }, this.getWidthsProps()), this.renderMenuItems()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
        linksAs = _this$props7.linksAs,
        centerMobileNavItems = _this$props7.centerMobileNavItems,
        hamburgerButtonPosition = _this$props7.hamburgerButtonPosition,
        backgroundColor = _this$props7.backgroundColor,
        invertedHamburgerButton = _this$props7.invertedHamburgerButton;
      var desktopNav = this.renderDesktopNav();
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "fshrm-navigation desktop-nav"
      }, desktopNav), /*#__PURE__*/React.createElement("div", {
        className: "fshrm-navigation mobile-nav"
      }, /*#__PURE__*/React.createElement(MobileMenu, {
        invertedHamburgerButton: invertedHamburgerButton,
        centerMobileNavItems: centerMobileNavItems,
        logo: this.getPrimaryContent(true),
        position: hamburgerButtonPosition,
        links: this.getLinks(true),
        linksAs: linksAs,
        className: this.getContainerClassNames(),
        backgroundColor: backgroundColor
      })));
    }
  }]);
  return Navigation;
}(React.Component);
export { Navigation as default };
Navigation.defaultProps = {
  group: true,
  backgroundColor: 'none',
  bordered: false,
  centerMobileNavItems: true,
  className: '',
  evenSpacing: false,
  fixed: false,
  invertedHamburgerButton: false,
  hamburgerButtonPosition: 'left',
  header: '',
  linksAs: 'span',
  logo: '',
  primaryContentPosition: 'left',
  primaryContentCentered: false
};
Navigation.propOptions = {
  backgroundColor: ['primary', 'none']
};
Navigation.dataPropsMap = {};